export const pkg = {
  name: 'isomorphic-git',
  version: '1.27.0',
  agent: 'git/isomorphic-git@1.27.0',
}
